<template>
  <form class="form-horizontal">
    <card>
      <div slot="header">
        <h4 class="card-title">{{crud}} Sinalização Digital</h4>
      </div>
      <div>

        <fg-input v-if="showMatriz" name="company" label="Empresa">
          <el-select
            class
            size="large"
            style="width: 100%"
            placeholder="Selecione a empresa dos usuários"
            v-model="model.company"
          >
            <el-option
              v-for="option in companyList"
              class
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </fg-input>

        <fg-input name="name" label="Nome" v-model="model.title"></fg-input>
        <fg-input
          name="vm"
          label="Vending machine">

          <el-select class=""
                      size="large"
                      style="width: 100%"
                      placeholder="Selecione a vending machine"
                      v-model="model.vm">
            <el-option v-for="opt in machines"
                        class=""
                        :value="opt.id"
                        :label="opt.location"
                        :key="opt.id">
            </el-option>
          </el-select>
        </fg-input>
        <fg-input label="Data início">
          <el-date-picker
            v-model="model.begin_date"
            type="datetime"
            format="dd/MM/yyyy"
            placeholder="Selecione"
          ></el-date-picker>
        </fg-input>
        <fg-input label="Data fim">
          <el-date-picker
            v-model="model.end_date"
            type="datetime"
            format="dd/MM/yyyy"
            placeholder="Selecione"
          ></el-date-picker>
        </fg-input>
      </div>
    </card>
    <card v-if="showVideo" class="col-sm-12">
      <div>
        <label>Videos</label>
      </div>
      <div class="img-upload" >
        <div class="col-sm-12 row" v-if="model.video">
            <video :src="model.video" width="320" height="240" 
              controls class="col-sm-12 " style="padding: 15px; margin-top: 15px" >
            </video>
        </div>
        <l-button  
          v-if="selectedFile.length !== 1 && !model.video"
          size="sm" 
          class="btn btn-social btn-round  btn-outline btn-info"
          @click="$refs.SelectFile.click()"
        >Adicionar novo video
        </l-button>
        <input 
          name="video"
          style="display: none" 
          label="Image" 
          type="file" 
          ref="SelectFile" 
          accept="video/*" 
          @change="selectFile" >
        <div class="col-sm-12 row">
          <div v-for="(path, index) in paths" :key="path.index" class="col-sm-6" >
            <video v-if="hasVideo" :src="path" width="320" height="240" 
              controls style="padding: 15px" class="col-sm-12">
            </video>
            <l-button  @click.prevent="removeVideo(index)" round class=" btn-danger btn col-sm-1 offset-sm-6">
              <i class="fa fa-times"></i>
            </l-button>
          </div>
        </div>
      </div>
    </card>
    <card v-else>
      Atualizando videos ....
    </card>
    <card>
      <div>
        <el-button type="primary" :loading="btnLoading" 
          @click.prevent="validate">Salvar</el-button>
      </div>
      <!-- <div class="block">
      <span class="demonstration">With default value</span>
      <el-color-picker v-model="color1"></el-color-picker>
    </div>
    {{color1}} -->
    </card>
  </form>
</template>
<script>
import { Select, Option, DatePicker, TimeSelect,Button, ColorPicker } from "element-ui";
import swal from "sweetalert2";
export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [DatePicker.name]: DatePicker,
    [ColorPicker.name]: ColorPicker,
    [Button.name]: Button,
  },
  data() {
    return {
      machines: [],
      crud: '',
      sazonal: [],
      selectedFile: [],
      companyList: [],

      paths: [],
      color1: '',
      btnLoading: false,
      showVideo: true,
      company: '',
      model: {
        vm: '',
        id: '',
        title: '',
        video: '',
        begin_date: '',
        end_date: '',
        company: ''
      }
    };
  },
  mounted () {
    if (this.$route.params.id) {
      this.crud = 'Editar'
      this.getData(this.$route.params.id)
    } else {
      this.crud = 'Criar'
    }
    const ciaID = localStorage.getItem('imachCiaID')
    if (ciaID) {
      this.getVM(ciaID)
    } else { 
      this.getVM()
    }
    if (this.showMatriz) {
      this.getListCompany()
    }
    this.$watch('model.company',()=>{
      this.$store.dispatch('general/flag', {id: this.model.company}).then(()=>{
        this.getVM(this.model.company)
      })
    })
  },
  computed: {
    showMatriz () {
      const matriz = localStorage.getItem("parent_company")
      if (matriz != 'null') {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    getVM (ciaID) {
      if (ciaID) {
        ciaID = ciaID
        this.company = ciaID
      } else {
        ciaID = ''
        this.company = this.$store.state.auth.company
      }
      this.$store.dispatch("machines/listSort",{sort: '?company=' + ciaID}).then(resp => {

        var y = this.$store.state.general.flag.filter(el => {
          if (el.feature === "V04"){
            if (el.active === true) {
              return el
            }
          }
        })
        var x = []
        this.machines = resp.map(el =>{
          return y.filter(ar =>{
            if (ar.vm == el.id) {
              x.push(el)
            }
          })

        })
        console.log('x', x)
        this.machines = x
      })
    },
    getListCompany () {
      this.$store.dispatch("company/list").then(resp => {
        this.companyList = resp.sort((a,b) => (a.name > b.name) ? 1 : (b.name > a.name) ? -1 : 0)
    
      })
    },
    getData (id) {
      this.$store.dispatch('sazonal/get',{id: id}).then(resp => {
        this.model = resp
      })
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    notifySuccess() {
      this.$notify({
        message: "Sucesso</br>Senha alterada!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
    },
    notifyError() {
      this.$notify({
        message: "Erro</br>Preencha todos os dados antes!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "danger"
      });
    },
    featureFlag () {
      console.log('feature')
      if (this.$store.state.general.flag !== undefined) {
        if (this.$store.state.auth.company === "null") {
          console.log('é null')
          this.showCombo = true
        }
        var y = this.$store.state.general.flag.filter(el => {
          if (el.feature === "C01"){
            if (el.active === true) {
              this.showCombo = true
            }
          }
        })
      } else {
        if (this.$store.state.auth.company === "null") {
          console.log('é null')
          this.showCombo = true
        }

      }
    },
    selectFile(e) {
      for (let index = 0; index < e.target.files.length; index++) {
        this.selectedFile.push(e.target.files[index]);
        this.paths.push(URL.createObjectURL(e.target.files[index]));
      }
      console.log('selec', this.selectedFile)
      console.log('path', this.paths)
      this.hasVideo = true;
    },
    async validate () {
      this.$validator.validateAll().then(isValid => {
      this.model.begin_date = new Date(this.model.begin_date).toISOString().split('T')[0]
      this.model.end_date = new Date(this.model.end_date).toISOString().split('T')[0]
        if (isValid && this.crud === "Criar") {
          this.videoUpload()
        } else if (isValid && this.crud === "Editar") {
          delete this.model.video
          this.btnLoading = true
          this.$store
            .dispatch("sazonal/update", { item: this.model })
            .then(() => {
              this.notifySuccess();
              this.$router.push(`/app/machines/videos`);
            }).catch(err => {
              this.btnLoading = false
              console.log(err)
              })
        }
    });

    },
    videoUpload() {
      this.btnLoading = true
      var formData = new FormData();
        formData.append("title", this.model.title);
        formData.append("video", this.selectedFile[0]);
        formData.append("begin_date", this.model.begin_date);
        formData.append("end_date", this.model.end_date);
        formData.append("vm", this.model.vm);
        formData.append("company", this.company);
        console.log('form', formData)
        this.$store
          .dispatch("sazonal/createForm", { item: formData })
          .then(resp => {
            this.selectedFile = []
            this.paths = []
            this.notifySuccess();
            this.$router.push(`/app/machines/videos`);
          }).catch(err => {
              this.btnLoading = false
              console.log(err)
              })
    },
    removeVideo (index) { // ativar botão no html para utilizar
      this.paths.splice(index,1)
      this.selectedFile.splice(index,1)
    }, 
  }
};
</script>
<style scoped>
.el-select {
  margin-bottom: 10px;
}
img {
  width: 200px;
}
.img-upload {
  border: 1px solid #ccc;
  border-radius: 5px;
  display: inline-block;
  padding: 10px;
  margin-bottom: 20px;
}
</style>
